const getWishlist = async (id) => {
  const res = await fetch(`https://youmna.sysc.app/api/wl/get-wishlist/${id}`);
  const r = await res.json();
  //console.log(r);
  let a = [];
  if (r.data) {
    r.data.list.map((p) => {
      a.push(p.variantId);
    });
  }
  const s = JSON.stringify({ id, list: r.data.list });
  localStorage.setItem("wl", s);
};

const initialWishlist = async () => {
  const wl = localStorage.getItem("wl");
  if (wl) {
    const wlid = JSON.parse(wl).id;
    getWishlist(wlid);
    const header = document.getElementById("header-wishlist");
    const sidebar = document.getElementById("sidebar-wishlist");
    header.setAttribute("href", `/pages/wishlist?list=${wlid}`);
    sidebar.setAttribute("href", `/pages/wishlist?list=${wlid}`);
  } else {
    console.log("no active wishlist");
  }
};

const wishlistCheckOnProductPage = async (vid) => {
  const wl = localStorage.getItem("wl");
  let check = false;
  if (wl) {
    const l = JSON.parse(wl).list;
    check = l.find((i) => {
      //console.log(vid, i.variantId);
      return i.variantId == vid;
    });
  }
  return check;
};

const handleWishlistOnClick = async (e) => {
  const wl = localStorage.getItem("wl");
  e.disabled = true;
  if (window.location.href.includes("/products/")) {
    e.getElementsByTagName("span")[0].style.display = "none";
    document.getElementById("loading-icon").style.display = "block";
  }

  let listId = "";
  let list = [];
  if (wl) {
    listId = JSON.parse(wl).id;
    list = JSON.parse(wl).list;
  }
  const data = {
    product: {
      productId: e.getAttribute("data-product-id"),
      variantId: e.getAttribute("data-variant-id"),
      name: e.getAttribute("data-product-name"),
      url: e.getAttribute("data-product-url"),
      img: e.getAttribute("data-product-img"),
      variantName: e.getAttribute("data-variant-name"),
      productBtn: e.getAttribute("data-product-button"),
    }
  };
  const action = e.getAttribute("data-action");
  try {
    if (action === "add") {
      const r = await fetch(`https://youmna.sysc.app/api/wl/add-product/${listId}`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
        'Content-Type': 'application/json'
        }
      });
      const m = await r.json();
      console.log(m);
      /*if (listId != "new") {
        console.log("not new");
        list.push(data.product);
      } else {
        console.log("new");
        console.log(m.result.wlid);
        list.push(data.product);
        listId = m.result.wlid;
      }*/
      triggerNotification("success", "Added to Wishlist");
      if (m.success) {
        listId = m.data.id
        list = m.data.list
      }
    }
    if (action === "remove") {
      if (wl) {
        list.map((p, index) => {
          if (p.variantId == data.product.variantId) {
            list.splice(index, 1);
          }
        });
      }
      const r = await fetch(`https://youmna.sysc.app/api/wl/remove-product/${listId}/${data.product.variantId}`);
      const m = await r.json();
      //console.log(m);
      if (m.success) {
        listId = m.data.id
        list = m.data.list
      }
      triggerNotification("success", "Removed from Wishlist");
    }
    
    const s = JSON.stringify({ id: listId, list: list });
    localStorage.setItem("wl", s);
    if (window.location.href.includes("/products/")) {
      e.getElementsByTagName("span")[0].innerText = e.getAttribute("data-text");
      e.getElementsByTagName("span")[0].style.display = "block";
      document.getElementById("loading-icon").style.display = "none";
    }
    if (window.location.href.includes("/pages/wishlist")) {
      renderWishlist();
    }
    e.disabled = false;
  } catch (error) {
    console.log(error);
    triggerNotification("failure", "Error: Please try again.");
  }
};

const appendWishlistParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  if (!searchParams.has("list")) {
    const wl = localStorage.getItem("wl");
    if (wl) {
      const wlid = JSON.parse(wl).id;
      window.location.href = window.location.href + `?list=${wlid}`;
    }
  }
};

const copyWishlistLink = () => {
  //e.preventDefault();
  const wl = localStorage.getItem("wl");
  let copyText = `https://youmnafinejewellery/pages/wishlist`;
  if (wl) {
    const wlid = JSON.parse(wl).id;
    copyText += `?list=${wlid}`;
  }
  navigator.clipboard.writeText(copyText);
  triggerNotification("success", "Link copied!");
};

const renderWishlist = async () => {
  let ownList = true;
  const wl = localStorage.getItem("wl");
  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.has("list")) {
    if (wl) {
      if (JSON.parse(wl).id != searchParams.get("list")) {
        ownList = false;
      }
    } else {
      ownList = false;
    }
  }

  const container = document.getElementById("wishlist-container");
  let html = "";
  if (ownList) {
    if (wl && JSON.parse(wl).list.length > 0) {
      listId = JSON.parse(wl).id;
      list = JSON.parse(wl).list;
      list.map((p, index) => {
        console.log(p.productBtn == "true");
        html += `<tr>
   <td>
      <line-item class="line-item" style="justify-content: space-between">
        <div style="display: flex; align-items: center;">
           <img src="//youmna-fine-jewellery.myshopify.com/cdn/shop/${
             p.img
           }?width=600" alt="${
          p.name
        }" srcset="//youmna-fine-jewellery.myshopify.com/cdn/shop/${
          p.img
        }?width=70 70w, //youmna-fine-jewellery.myshopify.com/cdn/shop/${
          p.img
        }?vwidth=120 120w, //youmna-fine-jewellery.myshopify.com/cdn/shop/${
          p.img
        }?width=140 140w, //youmna-fine-jewellery.myshopify.com/cdn/shop/${
          p.img
        }?width=210 210w, //youmna-fine-jewellery.myshopify.com/cdn/shop/${
          p.img
        }?width=240 240w, //youmna-fine-jewellery.myshopify.com/cdn/${
          p.img
        }?width=360 360w" width="600" height="436" loading="lazy" sizes="(max-width: 699px) 70px, 120px" class="line-item__media">
           <div class="line-item-info" style="margin-left: 8px;">
              <div class="v-stack justify-items-start gap-2">
                 <div class="v-stack justify-items-start gap-1"><a href="${
                   p.url
                 }?variant=${p.variantId}" class="h4">${p.name}</a></div>
                 <div class="v-stack justify-items-start gap-1">
                    <p class="smallcaps text-subdued">${p.variantName}</p>
                 </div>
                 <div style="display: flex; width: 150px; justify-content: space-between;" class="sm:hidden"><a href="${
                   p.url
                 }?variant=${
          p.variantId
        }" class="link text-xxs">View Product</a><button class="link text-xxs">Remove</button>
                 </div>
              </div>
           </div>
         </div>
         ${
           p.productBtn == "true"
             ? `<button class="button vs-button button--outline" id="add-to-cart" data-variantId="${p.variantId}" data-name="${p.name}">Add to Bag</button>`
             : `<button class="button vs-button button--outline">Enquire</button>`
         }
      </line-item>
   </td>
   <td class="text-center">
      <a href="${p.url}?variant=${
          p.variantId
        }" class="link text-xxs">View Product</a>
      <line-item-quantity class="v-stack justify-items-center gap-2" style="margin-top: 10px;">
         <button onclick={handleWishlistOnClick(this)} data-action="remove" data-variant-id="${
           p.variantId
         }" class="link text-xxs">Remove</button>
      </line-item-quantity>
   </td>
</tr>`;
      });
      container.innerHTML = html;
    } else {
      container.innerHTML = `<tr><td><div class="h4">No products in Your Wishlist yet.</div></td><td><div style="text-align: center;"><a href="/" class="link text-xxs">Back to Home</a></div></td></tr>`;
    }
  } else {
    /* not own list */
    const res = await fetch(
      `https://youmna.sysc.app/api/wl/get-wishlist/${searchParams.get("list")}`
    );
    const r = await res.json();
    if (!wl) {
      const s = JSON.stringify({ id: r.data.id, list: r.data.list });
      localStorage.setItem("wl", s);
    }
    //console.log(r);
    r.data.list.map((p, index) => {
      html += `<tr>
         <td>
            <line-item class="line-item" style="justify-content: space-between">
              <div style="display: flex; align-items: center;"> 
                 <img src="//youmna-fine-jewellery.myshopify.com/cdn/shop/${
                   p.img
                 }?width=600" alt="${
        p.name
      }" srcset="//youmna-fine-jewellery.myshopify.com/cdn/shop/${
        p.img
      }?width=70 70w, //youmna-fine-jewellery.myshopify.com/cdn/shop/${
        p.img
      }?vwidth=120 120w, //youmna-fine-jewellery.myshopify.com/cdn/shop/${
        p.img
      }?width=140 140w, //youmna-fine-jewellery.myshopify.com/cdn/shop/${
        p.img
      }?width=210 210w, //youmna-fine-jewellery.myshopify.com/cdn/shop/${
        p.img
      }?width=240 240w, //youmna-fine-jewellery.myshopify.com/cdn/${
        p.img
      }?width=360 360w" width="600" height="436" loading="lazy" sizes="(max-width: 699px) 70px, 120px" class="line-item__media">
                 <div class="line-item-info">
                    <div class="v-stack justify-items-start gap-2">
                       <div class="v-stack justify-items-start gap-1"><a href="${
                         p.url
                       }?variant=${p.variantId}" class="h4">${p.name}</a></div>
                       <div class="v-stack justify-items-start gap-1">
                          <p class="smallcaps text-subdued">${p.variantName}</p>
                       </div>
                       <div style="display: flex; width: 150px; justify-content: space-between;" class="sm:hidden"><a href="${
                         p.url
                       }?variant=${
        p.variantId
      }" class="link text-xxs">View Product</a><a href="#" class="link text-xxs">Remove</a>
                       </div>
                    </div>
                 </div>
              </div>
              ${
              p.productBtn == "true"
                ? `<button class="button vs-button button--outline" id="add-to-cart" data-variantId="${p.variantId}" data-name="${p.name}">Add to Bag</button>`
                : `<button class="button vs-button button--outline">Enquire</button>`
             }
            </line-item>
         </td>
         <td class="text-center">
            <a href="${p.url}?variant=${
        p.variantId
      }" class="link text-xxs">View Product</a>
            <line-item-quantity class="v-stack justify-items-center gap-2" style="margin-top: 10px;">
               <a href="#" onclick={handleWishlistOnClick(this)} data-action="remove" data-variant-id="${
                 p.variantId
               }" class="link text-xxs">Remove</a>
            </line-item-quantity>
         </td>
      </tr>`;
    });
    container.innerHTML = html;
  }
};

const addToCart = async (variantId, productName) => {
  try {
    let formData = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
    };

    const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const result = await response.json();
    const r = await fetch(
      `https://youmna.sysc.app/api/wl/remove-product/${listId}/${variantId}`
    );
    const m = await r.json();
    triggerNotification("success", `${productName} is added to Bag`);
    return result;
  } catch (error) {
    console.error("Error:", error);
  }
};
